import React from 'react';

interface TransactionsIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  style?: React.CSSProperties;
  spin?: boolean;
  rotate?: number;
  width?: number | string;
  height?: number | string;
}

const TransactionsMenuIcon: React.FC<TransactionsIconProps> = ({ className, style, spin = false, rotate, width='1.4em', height='1.4em', ...restProps }) => {
  const svgStyle = {
    ...style,
    ...(rotate && { transform: `rotate(${rotate}deg)` }),
    ...(spin ? { animation: 'spin 2s infinite linear' } : {}),
  };

  return (
    <span
      role="img"
      aria-label="transaction"
      className={`anticon anticon-transaction ${spin ? 'anticon-spin' : ''} ${className || ''}`}
      style={svgStyle}
    >
      <svg viewBox="5 5 45 40" fill="currentColor" width={width} height={height} focusable="false" {...restProps}>
        <path d="M24,5c-10.027,0 -18.247,7.788 -18.947,17.639l-0.346,-0.346c-0.392,-0.39 -1.022,-0.39 -1.414,-0c-0.39,0.39 -0.39,1.024 -0,1.414l2,2c0.392,0.391 1.022,0.391 1.414,0l2,-2c0.39,-0.39 0.39,-1.024 0,-1.414c-0.392,-0.39 -1.022,-0.39 -1.414,-0l-0.227,0.227c0.752,-8.69 8.05,-15.52 16.934,-15.52c0.551,0 0.998,-0.449 0.998,-1c0,-0.551 -0.447,-1 -0.998,-1Zm0,6c-7.175,0 -13,5.825 -13,13c0,7.175 5.825,13 13,13c7.175,0 13,-5.825 13,-13c0,-7.175 -5.825,-13 -13,-13Zm0,2c6.071,0 11,4.929 11,11c0,6.071 -4.929,11 -11,11c-6.071,0 -11,-4.929 -11,-11c0,-6.071 4.929,-11 11,-11Zm0,2.998c-0.552,0 -1,0.449 -1,1.002l0,1.352c-1.684,0.167 -2.998,1.586 -2.998,3.314l-0,0.002c-0,1.84 1.49,3.332 3.33,3.332l1.338,0c0.735,0 1.332,0.596 1.332,1.332l-0,0.004c-0,0.736 -0.597,1.33 -1.332,1.33l-0.619,0c-0.017,-0.001 -0.034,-0.002 -0.051,-0.002c-0.017,0 -0.034,0.001 -0.051,0.002l-2.947,0c-0.552,0 -1,0.448 -1,1c-0,0.552 0.448,1.002 1,1.002l1.998,-0l-0,1.332c-0,0.553 0.448,1 1,1c0.552,0 1,-0.447 1,-1l-0,-1.35c1.685,-0.166 3.002,-1.586 3.002,-3.314l-0,-0.004c-0,-1.84 -1.492,-3.332 -3.332,-3.332l-1.338,0c-0.735,0 -1.33,-0.596 -1.33,-1.332l-0,-0.002c-0,-0.736 0.595,-1.332 1.33,-1.332l3.67,-0c0.552,-0 1,-0.448 1,-1c-0,-0.552 -0.448,-1 -1,-1l-2.002,-0l-0,-1.334c-0,-0.553 -0.448,-1.002 -1,-1.002Zm18,6.002c-0.256,0 -0.511,0.097 -0.707,0.293l-2,2c-0.39,0.39 -0.39,1.024 -0,1.414c0.392,0.39 1.022,0.39 1.414,0l0.225,-0.225c-0.753,8.689 -8.049,15.518 -16.932,15.518c-0.551,0 -1,0.449 -1,1c-0,0.551 0.449,1 1,1c10.028,0 18.246,-7.789 18.945,-17.641l0.348,0.348c0.392,0.39 1.022,0.39 1.414,0c0.39,-0.39 0.39,-1.024 0,-1.414l-2,-2c-0.196,-0.196 -0.451,-0.293 -0.707,-0.293Z" />
      </svg>
    </span>
  );
};

export default TransactionsMenuIcon;
